import AddCardIcon from '@mui/icons-material/AddCard'
import AddCardOutlinedIcon from '@mui/icons-material/AddCardOutlined'
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined'
import { Button, Paper, styled, Switch, Typography, useMediaQuery } from '@mui/material'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import { isNull } from 'lodash'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RecurringPaymentStopDialog } from '../../../../dialogs/RecurringPaymentStopDialog'
import { useProfileStore } from '../../../../store/storeProfile'
import { theme } from '../../../../theme'

const ReferralBlockWrapper = styled(Paper)(({ isWebView }) => ({
    marginBottom: '16px',
    backgroundColor: '#fff',
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
    padding: '24px',
    height: '100%',
    border: isWebView ? 'none' : '1px solid #E9EAED',
    [theme.breakpoints.down('md')]: {
        padding: '12px',
    },
}))

export const RecurringPayment = ({ open, isWebView = false }) => {
    const { t } = useTranslation()
    const { recurringPayment, createRecurringPayment, changeRecurringPayment } = useProfileStore(
        (state) => state,
    )
    const [openRecurringPaymentStopDialog, setOpenRecurringPaymentStopDialog] =
        useState<boolean>(false)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const handelChangeEnabled = async () => {
        if (recurringPayment.is_active) {
            setOpenRecurringPaymentStopDialog(true)
        } else {
            await changeRecurringPayment({
                is_active: true,
                tariff_uuid: recurringPayment.tariff.id,
            })
        }
    }
    const handleCloseRecurringPaymentStopDialog = () => {
        setOpenRecurringPaymentStopDialog(false)
    }

    const handleClickChangePayment = async () => {
        if (recurringPayment) {
            await createRecurringPayment({
                is_active: true,
                minimum_amount: recurringPayment.minimum_amount,
                tariff_uuid: recurringPayment.tariff.id,
            })
        }
    }

    return (
        <ReferralBlockWrapper isWebView={isWebView}>
            <Typography
                sx={{
                    marginBottom: '12px',
                    color: '#000',
                }}
                variant="h3">
                {t('finances.autoReplenishment')}
            </Typography>

            {recurringPayment && isNull(recurringPayment.tariff) && (
                <>
                    <Typography
                        sx={{
                            color: '#5A5F72',
                            marginBottom: isMobile ? '16px' : 3,
                        }}
                        variant="body2">
                        {t('finances.connectAutoReplenishmentDesc')}
                    </Typography>
                    <Grid
                        sx={{
                            display: 'flex',
                            gap: '8px',
                        }}>
                        <Button
                            fullWidth={isMobile}
                            onClick={open}
                            startIcon={<AddCardIcon />}
                            variant="contained"
                            color="primary">
                            {t('finances.connectAutoReplenishmentBtn')}
                        </Button>
                    </Grid>
                </>
            )}

            {recurringPayment && !isNull(recurringPayment.tariff) && (
                <Stack sx={{ background: '#F5F5F5', borderRadius: '12px', padding: '12px' }}>
                    <Stack direction="row" alignItems="center" gap={1} mb={1}>
                        <Switch
                            size="small"
                            checked={recurringPayment.is_active}
                            onChange={handelChangeEnabled}
                        />
                        <Typography variant="body2" color="#5A5F72">
                            {t('finances.autoReplenishment')} {recurringPayment.is_active ? t('finances.autoReplenishmentConnected') : t('finances.autoReplenishmentDisconnected')}
                        </Typography>
                    </Stack>
                        <Typography variant="body2" color="#000">
                        {t('finances.whenBalanceLessThan', { amount: recurringPayment.minimum_amount })}
                    </Typography>
                    <Typography variant="body2" mb={1} color="#000">
                        {t('finances.replenishmentAmount', { 
                            amount: recurringPayment.tariff.price + recurringPayment.tariff.bonus_coins,
                            price: recurringPayment.tariff.price
                        })}
                    </Typography>
                    {recurringPayment.is_active && (
                        <Stack direction={isMobile ? 'column' : 'row'} gap={isMobile ? 1 : 2}>
                            <Link underline="hover" onClick={open} sx={{ cursor: 'pointer' }}>
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <EditNoteOutlinedIcon />
                                    {t('finances.changeParameters')}
                                </Stack>
                            </Link>
                            <Link
                                underline="hover"
                                onClick={() => handleClickChangePayment()}
                                sx={{ cursor: 'pointer' }}>
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <AddCardOutlinedIcon />
                                    {t('finances.changePaymentMethod')}
                                </Stack>
                            </Link>
                        </Stack>
                    )}
                </Stack>
            )}

            <RecurringPaymentStopDialog
                open={openRecurringPaymentStopDialog}
                handleClose={handleCloseRecurringPaymentStopDialog}
            />
        </ReferralBlockWrapper>
    )
}
